// Hook: the logged-in user's plan row (plan tier, manual slots, admin flag).
// Reads through the Supabase client — RLS restricts it to the user's own row.
// The is_admin flag only drives what the UI SHOWS; the real enforcement is
// the server-side 403 in api/chat.js / api/chat-purifier.js.
import { useEffect, useState } from 'react';
import { supabase } from './supabaseClient';
import { useAuth } from '../auth/AuthContext';

export function useMyPlan() {
  const { user } = useAuth();
  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!user || !supabase) {
      setPlan(null);
      return undefined;
    }
    let cancelled = false;
    setLoading(true);
    supabase
      .from('user_plans')
      .select('plan, max_manuals, is_admin')
      .single()
      .then(({ data }) => {
        if (!cancelled) {
          setPlan(data || null);
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [user]);

  return { plan, isAdmin: Boolean(plan?.is_admin), loading };
}
